import React from 'react';

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  stepLabels: string[];
  assets?: any;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  currentStep,
  totalSteps,
  stepLabels,
  assets,
}) => {
  return (
    <div className="w-full mb-8">
      <div className="flex items-start justify-between">
        {Array.from({ length: totalSteps }, (_, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;
          const isLast = index === totalSteps - 1;

          return (
            <div
              key={stepNumber}
              className="flex-1 flex flex-col items-center relative"
            >
              {/* Line to next step */}
              {!isLast && (
                <div
                  className="absolute left-[50%] right-[-50%] top-[20px] mx-6"
                  style={{
                    height: '2px',
                    background:
                      stepNumber < currentStep ? '#DA291C' : '#1F1F1F',
                    zIndex: 0,
                  }}
                />
              )}

              {/* Step Circle */}
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center relative z-10 ${
                  isActive || isCompleted
                    ? 'bg-[#DA291C] border-2 border-[#DA291C]'
                    : 'bg-white border-2 border-[#1F1F1F]'
                }`}
                style={{ borderRadius: '100px' }}
              >
                {isCompleted && assets?.check_mark ? (
                  <img
                    src={assets.check_mark}
                    alt="Completed"
                    className="w-5 h-5"
                  />
                ) : (
                  <span
                    className={`font-['Ted_Next'] text-[16px] font-[650] leading-[20px] tracking-[-0.051px] ${
                      isActive || isCompleted ? 'text-white' : 'text-[#1F1F1F]'
                    }`}
                  >
                    {stepNumber}
                  </span>
                )}
              </div>

              {/* Step Label */}
              <span
                className={`mt-2 text-xs text-center ${
                  isActive ? 'text-[#1F1F1F] font-medium' : 'text-gray-500'
                }`}
                style={{ maxWidth: '120px' }}
              >
                {stepLabels[index]}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressBar;
